// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".same-type-history-order[data-v-0fe45be8] {\n  padding: 1.25rem;\n}\n.empty-tip[data-v-0fe45be8] {\n  text-align: center;\n  color: #999;\n  padding: 2.5rem 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
